import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { DatePipe } from '@angular/common';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'beautyapp-user-delete-alert',
  imports: [
    DatePipe,
    NzModalFooterDirective,
    NzPopconfirmDirective,
    TranslatePipe
],
  templateUrl: './user-delete-alert.component.html',
  styleUrl: './user-delete-alert.component.scss'
})
export class UserDeleteAlertComponent {
  data = inject(NZ_MODAL_DATA);
  modalRef = inject(NzModalRef);

  bookings = this.data.bookings;
}
